import { BCMSDefaultModel, BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Card, Merchant } from "model";

/**
* @class RecurringPaymentMerchant
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.recurringPaymentMerchants[0];
* const RecurringPaymentMerchant = new transaction(record);
* @property {STRING} _id - id of the recurringPaymentMerchant
* @property {CARD} _card - type of recurringPaymentMerchant
* @property {MERCHANT} _merchant - type of recurringPaymentMerchant
*/

export default class RecurringPaymentMerchant extends BCMSRecord {
  _id 
  _card
  _merchant
  _status
  _doYouWantToContinueWithTheUpdate
  _didYouStoreYourCardWithThisMerchant
  _howWouldYouLikeToReceiveTheSecurityToken
  _securityToken
  _verificationMerchantUsername
  _verificationMerchantPassword
  _verificationMerchantSecurityCode

  constructor(record) {
    super(record)
  }

    /**
   * @function getClearedRecurringPaymentMerchant
   * @property {RecurringPaymentMerchant} recurringPaymentMerchant - Instance of recurringPaymentMerchant
   * @returns {RecurringPaymentMerchant}
   * @static
   * @description - Returns an instance of RecurringPaymentMerchant but with cleared properties, except for the
   * card and merchant. This function is used to clear the fields of the workflow its used in.
   * @memberof Destination
   */
  static getClearedRecurringPaymentMerchant(recurringPaymentMerchant) {
    const defaultRecurringPaymentMerchant = BCMSDefaultModel.recurringPaymentMerchant();
    defaultRecurringPaymentMerchant.id = recurringPaymentMerchant.id;
    defaultRecurringPaymentMerchant.merchant = recurringPaymentMerchant.merchant;
    defaultRecurringPaymentMerchant.card = recurringPaymentMerchant.card;
    return defaultRecurringPaymentMerchant;
  }
}

RecurringPaymentMerchant.define({
  "recordType": "recurringPaymentMerchants",
  "recordIDProp": "id",
  "className" : "RecurringPaymentMerchant",
  "recordProperties": [
   
    /** 
    * @name id
    * @instance
    * @property get {STRING} - gets the id of the recurringPaymentMerchant 
    * @property set {STRING} - sets the id of the recurringPaymentMerchant 
    * @memberof RecurringPaymentMerchant
    */
    BCMSRecordProperty.mapToString("id", "_id"),

    /** 
     * @name card
     * @instance
     * @property get {Merchant} - gets the card of the transactionDispute
     * @property set {Merchant} - sets the card of the transactionDispute 
     * @memberof RecurringPaymentMerchant
     */
    BCMSRecordProperty.mapToClass("card", "_card", () => Card),

    /** 
     * @name merchant
     * @instance
     * @property get {Merchant} - gets the merchant of the transactionDispute
     * @property set {Merchant} - sets the merchant of the transactionDispute 
     * @memberof RecurringPaymentMerchant
     */
    BCMSRecordProperty.mapToClass("merchant", "_merchant", () => Merchant),

    /** 
    * @name status
    * @instance
    * @property get {STRING} - gets the status of the recurringPaymentMerchant 
    * @property set {STRING} - sets the status of the recurringPaymentMerchant 
    * @memberof ecurringPaymentMerchant
    */
    BCMSRecordProperty.mapToString("status", "_status"),

    /** 
    * @name doYouWantToContinueWithTheUpdate
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof recurringPaymentMerchant
    */
    BCMSRecordProperty.mapToString("doYouWantToContinueWithTheUpdate", "_doYouWantToContinueWithTheUpdate"),

    /** 
    * @name didYouStoreYourCardWithThisMerchant
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof recurringPaymentMerchant
    */
    BCMSRecordProperty.mapToString("didYouStoreYourCardWithThisMerchant", "_didYouStoreYourCardWithThisMerchant"),

    /** 
    * @name howWouldYouLikeToReceiveTheSecurityToken
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof recurringPaymentMerchant
    */
    BCMSRecordProperty.mapToString("howWouldYouLikeToReceiveTheSecurityToken", "_howWouldYouLikeToReceiveTheSecurityToken"),

    /** 
    * @name securityToken
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof recurringPaymentMerchant
    */
    BCMSRecordProperty.mapToString("securityToken", "_securityToken"),

    /** 
    * @name verificationMerchantUsername
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof recurringPaymentMerchant
    */
    BCMSRecordProperty.mapToString("verificationMerchantUsername", "_verificationMerchantUsername"),

    /** 
    * @name verificationMerchantPassword
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof recurringPaymentMerchant
    */
    BCMSRecordProperty.mapToString("verificationMerchantPassword", "_verificationMerchantPassword"),

    /** 
    * @name verificationMerchantSecurityCode
    * @instance
    * @property get {STRING} - gets the answer to this question
    * @property set {STRING} - sets the answer to this question
    * @memberof recurringPaymentMerchant
    */
    BCMSRecordProperty.mapToString("verificationMerchantSecurityCode", "_verificationMerchantSecurityCode"),

  ]
})
